/**
 * Retorna a mensagem para `notFoundMessage` de um Autocomplete com busca server-side.
 *
 * Encapsula os três estados de feedback: input insuficiente, buscando e sem resultados.
 * Retorna `undefined` quando há resultados — nenhuma mensagem deve ser exibida.
 *
 * @param inputLength    - Comprimento atual do valor digitado no input
 * @param isQuerySuccess - `true` quando a última query completou com sucesso
 * @param resultsCount   - Número de resultados retornados pela query
 * @param messages       - Strings localizadas para cada estado
 *
 * @example
 * ```tsx
 * const msg = getAutocompleteSearchMessage(
 *   disciplineSearch.length,
 *   isDisciplineQuerySuccess,
 *   disciplineItems.length,
 *   {
 *     minChars: tCommon('search.minChars'),
 *     searching: tCommon('search.searching'),
 *     notFound:  tCommon('search.notFound'),
 *   },
 * );
 *
 * <Autocomplete
 *   {..*(msg !== undefined ? { notFoundMessage: msg } : {})}
 * />
 * ```
 */
export function getAutocompleteSearchMessage(
  inputLength: number,
  isQuerySuccess: boolean,
  resultsCount: number,
  messages: {
    readonly minChars: string;
    readonly searching: string;
    readonly notFound: string;
  },
): string | undefined {
  if (inputLength < 3) return messages.minChars;
  if (!isQuerySuccess) return messages.searching;
  if (resultsCount === 0) return messages.notFound;
  return undefined;
}
